import classNames from "classnames"

import { SessionLocalTimeSlot } from "modules/BookingCommon/components/DatePicker/utils"

interface Props {
    slots: SessionLocalTimeSlot[]
    slot?: SessionLocalTimeSlot
    OnSelect: (slot: SessionLocalTimeSlot) => void
}

export function SelectedDayAvailableHours(props: Props) {
    return (
        <>
            <div className="date-picker__select-time">Выберите время</div>
            <div className="date-picker__timezone">
                Указано ваше время: {Intl.DateTimeFormat().resolvedOptions().timeZone}
            </div>
            <div className="date-picker__slots">
                {props.slots.map((slot) => {
                    return (
                        <div
                            className={classNames("date-picker__slots__slot", {
                                "date-picker__slots__slot-selected": slot === props.slot,
                            })}
                            key={slot.id}
                            onClick={() => {
                                props.OnSelect(slot)
                            }}
                        >
                            {slot.localStart}
                        </div>
                    )
                })}
            </div>
        </>
    )
}
